import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import DisplaySettings from 'src/features/systems/components/displaySettings/DisplaySettings';
import { displaySettingsMessages } from 'src/features/systems/utils/displaySettingsMessages';
import { systemsMessages } from 'src/features/systems/utils/messages';
import { administrationMessages } from 'src/features/administration/utils/messages';
import SystemSettings from 'src/features/systems/routes/SystemSettings';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { useTitleStore } from 'src/stores/useTitleStore';

const TAB_QUERY_PARAM = 'tab';
const SYSTEM_SETTINGS_TAB = 'system-settings';
const DISPLAY_SETTINGS_TAB = 'display-settings';

const SystemSettingsLayout = () => {
    const { formatMessage } = useIntl();
    const [searchParams, setSearchParams] = useSearchParams();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(administrationMessages.settings));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    const tabFromUrl = searchParams.get(TAB_QUERY_PARAM);
    const activeTab = tabFromUrl === DISPLAY_SETTINGS_TAB ? DISPLAY_SETTINGS_TAB : SYSTEM_SETTINGS_TAB;

    const handleTabChange = (value: string) => {
        const next = new URLSearchParams(searchParams);
        if (value === SYSTEM_SETTINGS_TAB) {
            next.delete(TAB_QUERY_PARAM);
        } else {
            next.set(TAB_QUERY_PARAM, value);
        }
        setSearchParams(next, { replace: true });
    };

    return (
        <Tabs value={activeTab} onValueChange={handleTabChange}>
            <TabsList>
                <TabsTrigger value={SYSTEM_SETTINGS_TAB}>
                    <FormattedMessage {...systemsMessages.systemSettings} />
                </TabsTrigger>

                <TabsTrigger value={DISPLAY_SETTINGS_TAB}>
                    <FormattedMessage {...displaySettingsMessages.displaySettings} />
                </TabsTrigger>
            </TabsList>

            <TabsContent value={SYSTEM_SETTINGS_TAB}>
                <SystemSettings />
            </TabsContent>
            <TabsContent value={DISPLAY_SETTINGS_TAB}>
                <DisplaySettings />
            </TabsContent>
        </Tabs>
    );
};

export default SystemSettingsLayout;
